import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { getCampaignLeadsourceList } from "@/Api/AdminApiCall";

import { getCampaignLeadsourceList, getCampaignLeadStepList } from "../../Api/AdminApiCall";



// ✅ Fetch Campaign Lead Source List
export const fetchCampaignLeadsourceList = createAsyncThunk(
  "campaign/fetchCampaignLeadsourceList",
  async ({search, from_date, to_date, page, per_page}, { rejectWithValue }) => {
    try {
      const res = await getCampaignLeadsourceList(search, from_date, to_date, page, per_page);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to load campaign lead source list"
      );
    }
  }
);

// getCampaignLeadStepList
export const fetchCampaignLeadStepList = createAsyncThunk(
  "campaign/fetchCampaignLeadStepList",
  async ({search, from_date, to_date, page, per_page}, { rejectWithValue }) => {
    try {
      const res = await getCampaignLeadStepList(search, from_date, to_date, page, per_page);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to load campaign lead step list"
      );
    }
  }
);

const CampaignSlice = createSlice({
  name: "campaign",
  initialState: {
    campaignList: [],
    campaignstepList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignLeadsourceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignLeadsourceList.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignList = action.payload;
      })
      .addCase(fetchCampaignLeadsourceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCampaignLeadStepList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignLeadStepList.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignstepList = action.payload;
      })
      .addCase(fetchCampaignLeadStepList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export default CampaignSlice.reducer;
const CampaignSliceReducer = CampaignSlice.reducer;

export default CampaignSliceReducer;

// const AdminAffiliateSliceReducer = AdminAffiliateSlice.reducer;

// export default AdminAffiliateSliceReducer;